import AuthPages from 'components/AuthPages/AuthPages';
import FormLogin from 'components/FormLogin/FormLogin';

const Signin = () => {
  return (
    <AuthPages>
      <FormLogin />
    </AuthPages>
  );
};

export default Signin;
